module.exports = __webpack_public_path__ + "1dd4b316407fa61962a8789a317c8e3c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ribbons/numbers/1.png
// module id = 3426
// module chunks = 0